import type { UseMutationResult } from "@tanstack/react-query";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { toast } from "@/components/toast/toast-queue";
import { requestInternalNotesKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

export function useDeleteRequestInternalNote(
  requestId: number,
): UseMutationResult<Response, Error, number> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (noteId: number) =>
      apiClient
        .url(`/requests/${requestId}/internal-notes/${noteId}`)
        .delete()
        .res(),
    onError: () => {
      toast.add(
        { title: "Failed to delete note", type: "error" },
        { timeout: 5000 },
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: requestInternalNotesKeys.byRequestId(requestId),
      });
      toast.add(
        { title: "Note deleted successfully", type: "success" },
        { timeout: 3000 },
      );
    },
  });
}
